module.exports = __webpack_public_path__ + "img/2024big21.e99445aa.png";